import React from "react";
import RehabBanner from "../../assets/img/rehab_banner.jpg";
import AboutDriveImage2 from "../../assets/img/drive2.jpg";
import "../WhatDrivesUs.css";

export default function RehabBrochure() {
  return (
    <div className="wd-img top-img">
            <img src={RehabBanner} alt="Rehab Banner" />
          </div>
  );
}

